import React, {
    useCallback
} from 'react';
import { EHHO4PropertyDetailsComponent } from 'e1p-capability-policyjob-react';
import { WizardPage, wizardProps } from 'e1p-portals-wizard-react';

function ViewPropertyPage(props) {
    const { wizardData: policyChangeVM } = props;

    const onNext = useCallback(() => policyChangeVM, [policyChangeVM]);

    return (
        <WizardPage
            onNext={onNext}
            shouldLink
        >
            <EHHO4PropertyDetailsComponent
                onValidate={() => {}}
                transactionVM={policyChangeVM}
                updateWizardData={() => {}}
                isPageSubmitted={false}
                setShouldSkipAdditionalInfo={() => {}}
                isSavingCurrentPageChanges={false}
                isSkipping={false}
                isSavingEndorsement={false}
                viewOnly
            />
        </WizardPage>
    );
}

ViewPropertyPage.propTypes = wizardProps;
export default ViewPropertyPage;
